import { GameDiscoveriesResponseDTO, GameDiscoveriesResponseSchema } from '@hexcrawl/shared-utils';
import { requestJson } from './api';

export const discoveryService = {
  fetchDiscoveries(gameId: string): Promise<GameDiscoveriesResponseDTO> {
    return requestJson<GameDiscoveriesResponseDTO>({
      url: `/game/discoveries?gameId=${encodeURIComponent(gameId)}`,
      method: 'GET',
      schema: GameDiscoveriesResponseSchema,
    });
  },
};
